// src/components/ProtectedRoute.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const auth = useAuth();
  if (!auth.user) {
    // Jika tidak ada user, arahkan ke halaman login
    return <Navigate to="/login" />;
  }
  return children;
}

export default ProtectedRoute;